const Resize = (my_width) => {
  console.log("this is alizoka");
  console.log(my_width);
  console.log(window.innerWidth);
    return my_width
  if (my_width > 700) {
    return false
  } else {
    return true
  }
};

export default Resize;
